module.exports = __webpack_public_path__ + "static/media/logo-green.c4d87720.svg";